import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class AdminUserType {
  public readonly key = 'AdminUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Admin;
}
